export { InfoSection } from "./info";
